import { Outlet } from "react-router-dom";
import MainNavigation from "../components/MainNavigation";

function RootLayout(props) {
    return <>
        <MainNavigation isLoggedIn={props.isLoggedIn} onLogout={props.onLogout} />
        <main className="pageContent">
            <Outlet />
        </main>
    </>
}

export default RootLayout;